import React, {useState} from "react";
import Dropzone from "react-dropzone";
import './FileUploader.css'

function FileUploader(props) {
    const [files, setFiles] = useState(null);

    const handleDrop = acceptedFiles => {
        const file = acceptedFiles[0];

        if (file?.name?.toLowerCase()?.endsWith('.geojson')) {
            setFiles(file);

            if(props?.onGeoJsonLoaded){
                props?.onGeoJsonLoaded(file);
            }

        } else {
            if (props?.onWrongFiles) props?.onWrongFiles()
        }
    };


    return (
        <div>
            <div className='dropzone_wrapper'>
                <Dropzone style={{width: "100%", height: "100%", border: "none"}} onDrop={handleDrop}>
                    {({getRootProps, getInputProps}) => (
                        <section className='section_file_uploader'>
                            <div {...getRootProps()} className='section_file_uploader_div'>
                                <input {...getInputProps()} />
                                <p>
                                    {
                                        (files == null) ?
                                            'Trascina qui il geojson per caricarlo'
                                            :
                                            'Trascina qui un nuovo geojson per sostituire il precedente'
                                    }
                                </p>
                            </div>
                        </section>
                    )}
                </Dropzone>
            </div>
            {files && <li key={files.name}>{files.name} - {files.size} bytes</li>}
        </div>
    );
}

export default FileUploader;
